<script setup lang="ts">
import { cn } from '@/utils';
import {
	NavigationMenuTrigger,
	type NavigationMenuTriggerProps,
	useForwardProps
} from 'radix-vue';
import { computed, type HTMLAttributes } from 'vue';
import { navigationMenuTriggerStyle } from '.';

const props = defineProps<
	NavigationMenuTriggerProps & {
		class?: HTMLAttributes['class'];
		isNavOptionOpen?: boolean | undefined;
	}
>();

const isNavigationMenuOpen = defineModel<boolean>('mouse-over', {
	default: false
});

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<NavigationMenuTrigger
		v-bind="forwardedProps"
		:class="cn(navigationMenuTriggerStyle(), 'group', props.class)"
		@mouseover="isNavigationMenuOpen = true"
		@mouseleave="isNavigationMenuOpen = false"
	>
		<slot />
		<IconMaterialSymbolsLightChevronRight
			class="relative top-px ml-1 size-5 text-beige transition duration-300 group-data-[state=closed]:rotate-90 group-data-[state=open]:rotate-[270deg]"
			:class="{
				'!rotate-[270deg]': isNavOptionOpen
			}"
			aria-hidden="true"
		/>
	</NavigationMenuTrigger>
</template>
